<div
  class="relative w-full h-[280px] flex items-center justify-center rounded-xl overflow-hidden shadow-inner transition-colors duration-300"
  [style.backgroundColor]="primaryColor"
>
  <button
    class="absolute top-4 right-4 flex items-center justify-center w-8 h-8 rounded-full bg-black/10 hover:bg-black/20 text-white transition-all focus:outline-none backdrop-blur-md"
    (click)="close()"
    pTooltip="Close"
    tooltipPosition="bottom"
    tooltipStyleClass="custom-tooltip"
  >
    <i class="pi pi-times text-sm font-bold"></i>
  </button>

  <div *ngIf="loading" class="w-full h-full flex items-center justify-center px-8">
    <div class="flex flex-col items-center gap-5 w-full max-w-[320px] animate-pulse">
      <p-skeleton
        width="220px"
        height="90px"
        borderRadius="12px"
        styleClass="bg-white/20"
      ></p-skeleton>
      <p-skeleton
        width="140px"
        height="12px"
        borderRadius="999px"
        styleClass="bg-white/20"
      ></p-skeleton>
    </div>
  </div>

  <img
    *ngIf="!loading"
    [src]="logoSrc"
    alt="Tenant Preview"
    class="max-w-[70%] max-h-[120px] object-contain drop-shadow-lg"
  />

  <div
    class="absolute bottom-4 left-4 bg-black/10 text-white text-[10px] font-bold px-3 py-1.5 rounded-full backdrop-blur-md uppercase tracking-widest select-none"
  >
    Visual Preview
  </div>
</div>
